import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@/shared/components/Button';
import './UpdatePrompt.css';

/**
 * registerType: 'prompt' (set in vite.config.ts) means the new service
 * worker installs in the background but does NOT take over automatically --
 * needsRefresh only becomes true once a new version is ready and waiting.
 * Staff mid-scan at a booth choose when it's a good moment to reload rather
 * than the app yanking the rug out from under an active session.
 */
export function UpdatePrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Check for an updated service worker periodically -- staff may keep
      // the PWA open for an entire multi-day event without a full reload,
      // so relying solely on the "check on load" default would mean they'd
      // never see updates until they happened to fully relaunch the app.
      if (registration) {
        setInterval(() => void registration.update(), 60 * 60 * 1000); // hourly
      }
    }
  });

  if (needRefresh) {
    return (
      <div className="update-prompt" role="status">
        <span className="update-prompt__text">A new version is ready.</span>
        <div className="update-prompt__actions">
          <Button variant="ghost" onClick={() => setNeedRefresh(false)}>
            Later
          </Button>
          <Button variant="primary" onClick={() => void updateServiceWorker(true)}>
            Reload
          </Button>
        </div>
      </div>
    );
  }

  if (offlineReady) {
    return (
      <div className="update-prompt" role="status">
        <span className="update-prompt__text">Ready to work offline.</span>
        <div className="update-prompt__actions">
          <Button variant="ghost" onClick={() => setOfflineReady(false)}>
            Got it
          </Button>
        </div>
      </div>
    );
  }

  return null;
}
